import * as R from 'ramda'
import { RSAA } from 'redux-api-middleware'

const cachedResult = {}

export const readCache =
  ({ dispatch, getState }) =>
  next =>
  action => {
    const fluxAction = action[RSAA]

    if (fluxAction && fluxAction.method === 'GET' && fluxAction.cache) {
      const {
        endpoint: rawEndpoint,
        types: [, maybeSuccessType],
      } = fluxAction

      // the `maybeSuccessType` could be object or string,
      // turning the actionType string into object to match format.
      const { type: successType, meta: successTypeMeta } = R.when(
        R.is(String),
        R.objOf('type'),
      )(maybeSuccessType)

      const endpoint =
        typeof rawEndpoint === 'function'
          ? rawEndpoint(getState())
          : rawEndpoint

      if (cachedResult[endpoint]) {
        // if there's cache data dispatch the success action
        return dispatch({
          type: successType,
          meta: successTypeMeta,
          payload: cachedResult[endpoint],
        })
      } else {
        // if there's no cache data,
        // include `cache` and `cachedKey` into the `success` action meta,
        // and remove `cache` key from `RSAA` action.
        // So that the recordCache middleware knows whether and what to cache.
        const nextAction = R.pipe(
          R.set(R.lensPath([RSAA, 'types', 1]), {
            type: successType,
            meta: {
              ...successTypeMeta,
              cache: true,
              cacheKey: endpoint,
            },
          }),
          R.dissocPath([RSAA, 'cache']),
        )(action)
        return next(nextAction)
      }
    }

    // make sure that `cache` doesn't get through or else
    // redux-api-middleware will barf on you.
    if (fluxAction) delete action[RSAA].cache

    return next(action)
  }

export const recordCache = () => next => action => {
  const { meta: { cache, cacheKey } = {} } = action
  if (cache && !!cacheKey && action.payload) {
    cachedResult[cacheKey] = action.payload
  }
  return next(action)
}

export const clearApiCache = () => {
  Object.keys(cachedResult).forEach(key => {
    delete cachedResult[key]
  })
}
